import gql from 'graphql-tag';

export const CALENDAR_EVENT_FRAGMENT = gql`
  fragment CalendarEventFields on CalendarEventViewModel {
    id
    allDay
    subject
    priority
    eventType
    description
    activityStatus

    endAt
    startAt
    endDate
    startDate

    isOwnEvent

    owner {
      id
      fullName
    }

    sharing {
      type
      color
      isOwnEvent
    }
  }
`;
